import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { BaseService } from '../../../shared/base.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-admin-setting-search',
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
})
export class AppAdminSettingSearchComponent implements OnInit {

    @Input() languages: any;
    @Input() searchInfo: any;
    @Input() itemLanguage: string;
    @Input() showLanguage: boolean = true;

    @Output() searchData = new EventEmitter<any>();
    @Output() changeLanguage = new EventEmitter<any>();
    
    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        ) {
    }

    ngOnInit() {

    }
}
